import { validateCNPJ, validateCPF } from 'validations-br';
import * as Yup from 'yup';

function validateRegistryCode(value) {
  if (!value) return true;
  return value?.length === 11 ? validateCPF(value) : validateCNPJ(value);
}

const regexEmail = /^[a-zA-Z0-9.!#$%&`*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
const regexMobile = /^\([1-9]{2}\) (?:[9]|9[1-9])[0-9]{3}-[0-9]{4}$/;

const requiredFieldMessage = 'Campo obrigatório';
const validateMobileMessage = 'Deve ter pelo menos 9 números';
const validateMobileDigit = 'Deve começar com número 9';
const validateLandineMessage = 'Deve ter pelo menos 8 números';
const validateEmailMessage = 'Não é um e-mail válido';
const validateCCEmailMessage = 'No máximo 3 e-mails';

const validationSchema = Yup.object().shape({
  name: Yup.string().required(requiredFieldMessage),
  email: Yup.string().matches(regexEmail, validateEmailMessage),
  registry_code: Yup.string().test(
    'is-registry_code',
    'Documento inválido',
    validateRegistryCode,
  ),
  notes: Yup.string(),
  code: Yup.string(),
  address_attributes: Yup.object().shape({
    zipcode: Yup.string(),
    additional_details: Yup.string(),
    street: Yup.string().nullable(),
    number: Yup.string().nullable(),
    neighborhood: Yup.string().nullable(),
    state: Yup.string().nullable(),
    city: Yup.string().nullable(),
    country: Yup.string().nullable(),
  }),
  phones_attributes: Yup.array().of(Yup.object().shape({
    country_code: Yup.string(),
    area_code: Yup.string(),
    phone_type: Yup.string().when('local', {
      is: (value) => value && value?.length > 0,
      then: Yup.string().required(requiredFieldMessage),
      otherwise: Yup.string(),
    }),
    local: Yup.string().when('phone_type', {
      is: (value) => value && value === 'mobile',
      then: Yup.string().min(15, validateMobileMessage).matches(regexMobile, validateMobileDigit),
      otherwise: Yup.string().min(14, validateLandineMessage),
    }),
    extension: Yup.string(),
  }, ['local', 'phone_type'])),
  metadata_attributes: Yup.object().shape({
    _bank_slip_due_day: Yup.string(),
    _invoice_issuing_type: Yup.string(),
    _integration_nfeio_taxation: Yup.string(),
    _cc_email: Yup.array().max(3, validateCCEmailMessage),
  }),
});

const initialValues = (isMobile) => ({
  name: '',
  email: '',
  registry_code: '',
  address_attributes: {
    zipcode: '',
    country: 'BR',
    additional_details: '',
    street: '',
    number: '',
    neighborhood: '',
    state: '',
    city: '',
  },
  phones_attributes: [{
    country_code: '+55', area_code: '', local: '', phone_type: isMobile ? 'mobile' : '', extension: '',
  }],
  notes: '',
  code: '',
});

export {
  validationSchema,
  initialValues,
};
